
import { Vue, Component, Prop, Model } from "vue-property-decorator";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import UiButton from "@/components/button/ui-button.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import CircleWithInitials from "@/components/card/CircleWithInitialsInbox.vue";
import ConversationParticipants from "@/entities/ConversationParticipants";
import ConversationUserData from "@/entities/ConversationUserData";


@Component({
  components: {
    UiButton,
    ModalFullScreen,
    FormGroup,
    CrossIcon,
    CrossIconHover,
    CircleWithInitials,
  },
})
export default class ConversationDetailsModal extends Vue {
  @Model("toggle", { type: Boolean, default: false }) readonly isOpen!: boolean;
  @Prop({ type: String, default: undefined }) readonly currentUserId?: string;
  @Prop({ type: String, default: undefined }) readonly companyId?: string;
  @Prop({type: String, default: undefined}) readonly conversationName?: string;
  @Prop({type: Object, default: () => ({})}) readonly participants!: ConversationParticipants;

  isHovered:boolean = false;

  participantStatusStyle(participant: ConversationUserData) {
    return participant.deleted ? 'opacity-25': 'opacity-100';
  }

  handleClose(): void {
    this.$emit('toggle', false);
  }

  handleLeaveConversation(): void {
    this.$emit('leaveConversation');
    this.handleClose();
  }
}
